import React from 'react';
import KoobBadge from '@koob/ui/src/components/KoobBadge';
import { formatRelative } from '@koob/dates';

interface TripVersionRowProps {
  version: any;
  label: React.ReactNode;
  byLabel: React.ReactNode;
  isCurrent: boolean;
  isCompared: boolean;
  onSelect: () => void;
}

// One version of the list: its number, its author and the role that wrote it.
export default function TripVersionRow({
  version,
  label,
  byLabel,
  isCurrent,
  isCompared,
  onSelect,
}: TripVersionRowProps) {
  const role = version.user.role?.name;

  return (
    <div
      onClick={onSelect}
      className={[
        'w-full hover:bg-gray-50 py-3 px-4 border-l-4 transition cursor-pointer',
        isCurrent && 'border-orange-500',
        isCompared && 'border-blue-500',
      ].join(' ')}
    >
      <div className="w-full flex justify-between items-center">
        <div className="w-56">
          <div className="text-sm font-medium text-gray-700">
            {label} {version.version}
          </div>

          <div className="text-xs font-medium text-gray-500">
            {byLabel} {version.user.name}
            <div className="mt-1 flex gap-1">
              {['dmc_admin', 'dmc_user'].includes(role) && (
                <KoobBadge color="purple">DMC</KoobBadge>
              )}
              {['to_admin', 'to_user'].includes(role) && (
                <KoobBadge color="orange">TO</KoobBadge>
              )}
            </div>
          </div>
        </div>

        <div className="text-xs text-gray-400">
          {formatRelative(version.createdAt)}
        </div>
      </div>
    </div>
  );
}
